import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  getDudaConfiguration,
  type GetDudaConfigurationResponse,
} from 'api/admin/businesses/dudaConfiguration';

export const useGetDudaConfiguration = (businessId: number) => {
  const { isLoading, error, data, refetch } = useQuery<
    unknown,
    AxiosError<{ error: string }>,
    GetDudaConfigurationResponse
  >({
    queryKey: ['getDudaConfiguration', businessId],
    queryFn: async () => {
      const response = await getDudaConfiguration(businessId);
      return response.data ?? {};
    },
    retry: 1,
    onError: (error) => {
      if (error?.response?.status === 404) return;

      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching duda configuration',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
